import { ColoursObj } from '@eventr/common-storybook'
import { Box, Card, Skeleton, Stack } from '@mui/material'

export default function SkeletoScreen() {
    return (
        <Box>
            <Stack gap="16px" alignContent="center" padding="8px">
                <Card
                    style={{
                        backgroundColor: ColoursObj.backgrounds.secondary,
                        padding: ' 8px 16px',
                    }}
                >
                    <Stack gap={'12px'}>
                        <Stack
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                        >
                            <Stack
                                flexDirection={'row'}
                                gap={'12px'}
                                width="30%"
                            >
                                <Skeleton
                                    sx={{
                                        bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                                    }}
                                    variant="circular"
                                    width="24px"
                                    height="18px"
                                    animation="wave"
                                />
                                <Skeleton
                                    sx={{
                                        bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                                    }}
                                    variant="rounded"
                                    width="100%"
                                    animation="wave"
                                />
                            </Stack>
                            <Skeleton
                                sx={{
                                    bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                                }}
                                variant="rounded"
                                width="20%"
                                animation="wave"
                            />
                        </Stack>

                        <Skeleton
                            sx={{
                                bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                            }}
                            variant="rounded"
                            width="100%"
                            animation="wave"
                        />
                        <Skeleton
                            sx={{
                                bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                            }}
                            variant="rounded"
                            width="100%"
                            animation="wave"
                        />
                    </Stack>
                </Card>
                <Card
                    style={{
                        backgroundColor: ColoursObj.backgrounds.secondary,
                        padding: ' 8px 16px',
                    }}
                >
                    <Stack gap={'12px'}>
                        <Stack
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                        >
                            <Stack
                                flexDirection={'row'}
                                gap={'12px'}
                                width="30%"
                            >
                                <Skeleton
                                    sx={{
                                        bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                                    }}
                                    variant="circular"
                                    width="24px"
                                    height="18px"
                                    animation="wave"
                                />
                                <Skeleton
                                    sx={{
                                        bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                                    }}
                                    variant="rounded"
                                    width="100%"
                                    animation="wave"
                                />
                            </Stack>
                            <Skeleton
                                sx={{
                                    bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                                }}
                                variant="rounded"
                                width="20%"
                                animation="wave"
                            />
                        </Stack>

                        <Skeleton
                            sx={{
                                bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                            }}
                            variant="rounded"
                            width="100%"
                            animation="wave"
                        />
                        <Skeleton
                            sx={{
                                bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                            }}
                            variant="rounded"
                            width="100%"
                            animation="wave"
                        />
                    </Stack>
                </Card>
                <Card
                    style={{
                        backgroundColor: ColoursObj.backgrounds.secondary,
                        padding: ' 8px 16px',
                    }}
                >
                    <Stack gap={'12px'}>
                        <Stack
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                        >
                            <Stack
                                flexDirection={'row'}
                                gap={'12px'}
                                width="30%"
                            >
                                <Skeleton
                                    sx={{
                                        bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                                    }}
                                    variant="circular"
                                    width="24px"
                                    height="18px"
                                    animation="wave"
                                />
                                <Skeleton
                                    sx={{
                                        bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                                    }}
                                    variant="rounded"
                                    width="100%"
                                    animation="wave"
                                />
                            </Stack>
                            <Skeleton
                                sx={{
                                    bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                                }}
                                variant="rounded"
                                width="20%"
                                animation="wave"
                            />
                        </Stack>

                        <Skeleton
                            sx={{
                                bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                            }}
                            variant="rounded"
                            width="100%"
                            animation="wave"
                        />
                        <Skeleton
                            sx={{
                                bgcolor: `${ColoursObj.coreBrights.tertiary}35`,
                            }}
                            variant="rounded"
                            width="100%"
                            animation="wave"
                        />
                    </Stack>
                </Card>
            </Stack>
        </Box>
    )
}
